module.exports = __webpack_public_path__ + "static/banner-244d0a83f27b71066948ef51afae38bd.svg";